import React from 'react';
import img from './images/imagen-previsualizar.jpeg'

export default function Img() {
  return (
    <div>
      <img src={img} alt="Ecoscooting"/>
    </div>
  )
}